export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function removeUndefined(value: any): any {
  Object.keys(value).forEach(key => value[key] === undefined && delete value[key]);

  return value;
}

export function updateArrayItem(arr: any[], id: number, updatedData: Partial<any>): any[] {
  return arr.map(item => (item.id === id ? { ...item, ...updatedData } : item));
}

export function areObjectsEqual(object1: any, object2: any): boolean {
  if (isNullOrUndefined(object1) || isNullOrUndefined(object2)) {
    return object1 === object2;
  }

  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }
  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }
  return true;
}

export function arePropertiesEqual(property1: any, property2: any): boolean {
  let r = false;
  if (property1 === undefined || (property1 === null && property2 === undefined) || property2 === null) {
    r = true;
  }
  r = property1 == property2;
  return r;
}

export function areArraysEqual(array1: any[], array2: any[]): boolean {
  if (array1.length !== array2.length) {
    return false;
  }
  if (array1.length === 0 && array2.length === 0) {
    return true;
  }

  for (let i = 0; i < array1.length; i++) {
    if (typeof array1[i] !== typeof array2[i]) {
      return false;
    }
    if (typeof array1[i] === 'object' && typeof array2[i] === 'object') {
      if (!areObjectsEqual(array1[i], array2[i])) {
        return false;
      }
      continue;
    }
    if (array1[i] !== array2[i]) {
      return false;
    }
  }
  return true;
}

export function undefinedPropsToNull(value: any): any {
  if (!value) {
    return value;
  }

  Object.keys(value).forEach(key => {
    if (value[key] === undefined) {
      value[key] = null;
    }
  });

  return value;
}

export function isSerializableObject(target): boolean {
  const isArray = (target): boolean => {
    return Array.isArray(target);
  };

  const isObjectLike = (target): boolean => {
    return typeof target === 'object' && target !== null;
  };

  const isObject = (target): boolean => {
    return isObjectLike(target) && !isArray(target);
  };

  if (!isObject(target)) {
    return false;
  }

  const targetPrototype = Object.getPrototypeOf(target);

  return targetPrototype === Object.prototype || targetPrototype === null;
}
